var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChipOnlyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.172 20.828C4.343 22 6.229 22 10 22C13.771 22 15.657 22 16.828 20.828C17.999 19.656 18 17.771 18 14C17.9995 13.4925 17.8989 12.99 17.704 12.5214C17.509 12.0528 17.2236 11.6272 16.864 11.269L12.731 7.136C12.3728 6.7764 11.9472 6.49096 11.4786 6.29603C11.01 6.1011 10.5075 6.00051 10 6C6.229 6 4.343 6 3.172 7.172C2.001 8.344 2 10.229 2 14C2 17.771 2 19.657 3.172 20.828Z",
    stroke: "#0E49DE",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0001 17.899C19.3001 17.771 20.175 17.482 20.828 16.829C22 15.656 22.0001 13.77 22.0001 10C21.9995 9.49245 21.8989 8.98999 21.704 8.52137C21.5091 8.05275 21.2237 7.62717 20.8641 7.269L16.7311 3.136C16.373 2.77652 15.9476 2.49115 15.4791 2.29623C15.0107 2.1013 14.5084 2.00064 14.0011 2C10.2291 2 8.34305 2 7.17105 3.172C6.51905 3.825 6.23005 4.7 6.10205 6M10.0001 14H9.00005C8.05705 14 7.58605 14 7.29305 14.293C7.00005 14.586 7.00005 15.057 7.00005 16V17C7.00005 17.943 7.00005 18.414 7.29305 18.707C7.58605 19 8.05705 19 9.00005 19H10.0001M10.0001 14H11.0001C11.9431 14 12.4141 14 12.7071 14.293C13.0001 14.586 13.0001 15.057 13.0001 16V16.5M10.0001 14V16.5M10.0001 19H11.0001C11.9431 19 12.4141 19 12.7071 18.707C13.0001 18.414 13.0001 17.943 13.0001 17V16.5M10.0001 19V16.5M13.0001 16.5H10.0001",
    stroke: "#0E49DE",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChipOnlyIcon);
export default __webpack_public_path__ + "static/media/chipOnlyIcon.7327e63918c7001351ae534767bfd97c.svg";
export { ForwardRef as ReactComponent };